<template>
  <v-card class="elevation-0">
    <v-row class="pa-0 ma-0">
      <v-col cols="6">
        <v-card class="mx-auto">
          <v-card-text>
            <HelpFormInput
              v-model="name"
              label="Placement Name"
              placeholder="Placement Name"
              help-text="Give recognizable name to your Ad Placement Item."
              :rules="rules.name"
              @update:model-value="(v) => onUpdate({ ...modelValue, name: v })"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="mx-auto">
          <!-- <v-card-title> Device Specs </v-card-title> -->
          <v-img
            class="align-end text-white"
            height="200"
            src="/screen-specs.webp"
            contain
          />
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <HelpFormInput
                  v-model="resolutionX"
                  label="Resolution X (px)"
                  placeholder="Resolution X"
                  help-text="The resolution of the device in X direction."
                  :rules="rules.resolutionX"
                  @update:model-value="
                    (v) => onUpdate({ ...modelValue, resolutionX: v })
                  "
                />
              </v-col>
              <v-col cols="6">
                <HelpFormInput
                  v-model="resolutionY"
                  label="Resolution Y (px)"
                  placeholder="Resolution Y"
                  help-text="The resolution of the
                    device in Y direction."
                  :rules="rules.resolutionY"
                  @update:model-value="
                    (v) => onUpdate({ ...modelValue, resolutionY: v })
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
  
  
  <script>
import HelpFormInput from "../../atoms/common/inputs/HelpFormInput.vue";

export default {
  components: {
    HelpFormInput,
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        name: null,
        serialNumber: null,
        width: 0,
        height: 0,
        resolutionX: 0,
        resolutionY: 0,
      }),
    },
  },
  emits: ["next", "update:modelValue"],
  data() {
    return {
      name: null,
      serialNumber: null,
      width: 0,
      height: 0,
      resolutionX: 0,
      resolutionY: 0,

      rules: {
        name: [
          (v) => !!v || "Name is required",
          (v) =>
            (v && v.length <= 50) || "Name must be less than 50 characters",
        ],
        serialNumber: [
          (v) => !!v || "Serial number is required",
          (v) =>
            (v && v.length <= 20) ||
            "Serial number must be less than 20 characters",
          // srial number example": "1234567890ABCDEF"
          (v) =>
            /^[a-zA-Z0-9]+$/.test(v) || "Serial number must be alphanumeric",
        ],
        width: [
          (v) => !!v || "Width is required",
          (v) => (v && v > 0) || "Width must be greater than 0",
        ],
        height: [
          (v) => !!v || "Height is required",
          (v) => (v && v > 0) || "Height must be greater than 0",
          (v) => /^[0-9]+$/.test(v) || "Height must be a number",
        ],
        resolutionX: [
          (v) => !!v || "Resolution X is required",
          (v) => (v && v > 0) || "Resolution X must be greater than 0",
        ],
        resolutionY: [
          (v) => !!v || "Resolution Y is required",
          (v) => (v && v > 0) || "Resolution Y must be greater than 0",
        ],
      },
    };
  },
  computed: {},

  created() {},
  methods: {
    onUpdate(value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>